module.exports = __webpack_public_path__ + "media/images/terms-app-image-c16a829817ddb229cfd53bc76d391bca.png";